import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ga4 } from "src/libs/ga4";

/** GA4를 초기화하고 React Router의 실제 경로 변경을 page_view로 기록한다. */
export const useGoogleAnalytics = (config) => {
  const location = useLocation();

  useEffect(() => {
    ga4.initialize(config);
  }, [config]);

  useEffect(() => {
    ga4.pageView(`${location.pathname}${location.search}`);
  }, [location.pathname, location.search]);
};
